// extracted by mini-css-extract-plugin
export default {"root":"Bullets_root__z-LSg"};